import { styled } from "../../../styled-components";

export const WebviewWrapper = styled.div<{ explicitHeight: number | undefined }>`
    height: 0px;
    width: 100%;
    overflow: hidden;
    position: relative;

    & > iframe {
        border: 0px;
        width: 100%;
        height: 100%;
        position: absolute;
    }

    &.inline-link-three-by-one {
        padding-bottom: calc(100% / 3);
    }

    &.inline-link-three-by-two {
        padding-bottom: calc(100% * 2 / 3);
    }

    &.inline-link-square {
        padding-bottom: 100%;
    }

    &.inline-link-three-by-four {
        padding-bottom: calc(100% * 4 / 3);
    }

    &.inline-link-fill {
        padding-bottom: 100%;
        flex-grow: 1;
    }

    &.inline-link-expand {
        flex: 1;
    }

    &.inline-link-explicit {
        padding-bottom: ${p => p.explicitHeight}px;
    }

    & > div.embedding-not-possible {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;

        background-color: ${p => p.theme.offBaseColor};
        color: ${p => p.theme.fgColorOffBase} !important;
        ${p => p.theme.fontStyles.AccentHeader4};
        text-align: center;

        & > div.no-container {
            margin-bottom: 8px;
        }

        padding: 0px 46px 0px 46px;
        position: absolute;

        & > button {
            margin-top: 12px;
            ${p => p.theme.fontStyles.Subheader3};
        }
    }
`;
